module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "people-warp"
  }, [_c('div', {
    staticClass: "head-title"
  }, [_c('div', {
    staticClass: "pic",
    staticStyle: {
      "background-image": "url('static/images/ex_pic16.jpg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.personnelDetail.name))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('span', {
    staticClass: "code-number"
  }, [_vm._v("执业证号：" + _vm._s(_vm.personnelDetail.codeNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('span', {
    staticClass: "company"
  }, [_vm._v("执业机构：" + _vm._s(_vm.personnelDetail.company))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "cont-warp"
  }, [_c('div', {
    staticClass: "message-warp"
  }, [_c('div', {
    staticClass: "go-out-message"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("外出办证信息")]), _vm._v(" "), _c('p', [_vm._v("公证事项:" + _vm._s(_vm.personnelDetail.goOut.matter))]), _vm._v(" "), _c('p', [_vm._v("申请人:" + _vm._s(_vm.personnelDetail.goOut.applicant))]), _vm._v(" "), _c('p', [_vm._v("核准地址:" + _vm._s(_vm.personnelDetail.goOut.address))])]), _vm._v(" "), _c('div', {
    staticClass: "go-out-map"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("公证员现在位置")]), _vm._v(" "), _c('innerMap')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "server-warp"
  }, [_c('div', {
    staticClass: "title-go-out"
  }, [_vm._v("外出动态")]), _vm._v(" "), _c('out-list', {
    attrs: {
      "outList": _vm.personnelDetail.dynamic
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goback(true)
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "git-in-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-photograph"
  }), _vm._v("\n        实时监控\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c45e31a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/people.vue
// module id = 178
// module chunks = 1